
import React from 'react';

interface AlertModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    type?: 'error' | 'success' | 'info';
}

const AlertModal: React.FC<AlertModalProps> = ({ isOpen, onClose, title, message, type = 'info' }) => {
    if (!isOpen) return null;

    const isError = type === 'error';
    const isSuccess = type === 'success';

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-gray-900/40 dark:bg-black/60 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            />

            {/* Modal Content */}
            <div className="relative bg-white dark:bg-gray-900 rounded-[2rem] shadow-2xl p-8 max-w-sm w-full mx-4 border border-gray-100 dark:border-gray-800 transform transition-all animate-in zoom-in-95 duration-200">
                <div className="flex flex-col items-center text-center space-y-6">

                    {/* Icon */}
                    <div className={`w-20 h-20 rounded-3xl flex items-center justify-center text-4xl shadow-lg mb-2 ${isError ? 'bg-red-50 text-red-500 dark:bg-red-900/20 dark:text-red-400' :
                            isSuccess ? 'bg-green-50 text-green-500 dark:bg-green-900/20 dark:text-green-400' :
                                'bg-indigo-50 text-indigo-500 dark:bg-indigo-900/20 dark:text-indigo-400'
                        }`}>
                        {isError ? '⚠️' : isSuccess ? '✨' : 'ℹ️'}
                    </div>

                    {/* Text */}
                    <div className="space-y-2">
                        <h3 className="text-xl font-black text-gray-900 dark:text-white leading-tight">
                            {title}
                        </h3>
                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400 leading-relaxed">
                            {message}
                        </p>
                    </div>

                    {/* Button */}
                    <button
                        onClick={onClose}
                        className={`w-full py-4 rounded-xl font-bold text-white shadow-xl transition-all hover:scale-[1.02] active:scale-[0.98] ${isError ? 'bg-red-500 shadow-red-200 dark:shadow-none hover:bg-red-600' :
                                isSuccess ? 'bg-green-500 shadow-green-200 dark:shadow-none hover:bg-green-600' :
                                    'bg-gray-900 dark:bg-white dark:text-gray-900 shadow-gray-200 dark:shadow-none hover:bg-black dark:hover:bg-gray-100'
                            }`}
                    >
                        Okay, Got it
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AlertModal;
